export default __webpack_public_path__ + "static/media/division.9ce1056b.svg";